import React, { useState } from 'react'
import './styles.css'
import { usePainting } from 'providers/PaintingProvider'
import { useStatus } from 'providers/ApiStatusProvider'
import { Painting } from 'models/painting'
import api from 'api'
import { setPaintings } from 'store/slidesSlice'

const AddPainting = ({ oldVersion, isEditing, setEditing }) => {
  const { painting, setPainting } = usePainting()
  const { setStatus } = useStatus()
  const handleInputChange = event => {
    const { name, value } = event.target
    setPainting({ ...painting, [name]: value })
  }

  const [image, setImage] = useState({ preview: '', data: '' })
  //make this is context

  const handleSubmit = async e => {
    e.preventDefault()
    if (isEditing) {
      api.editPainting(oldVersion, painting, image, setPaintings, setEditing)
    } else {
      api.addPainting(painting, image, setStatus)
    }
  }

  const handleFileChange = e => {
    const img = {
      preview: URL.createObjectURL(e.target.files[0]),
      data: e.target.files[0],
    }
    setImage(img)
  }

  return (
    <form
      className="form"
      onSubmit={event => {
        event.preventDefault()
        if (!painting.name || !painting.year) return
        handleSubmit(event)
        //commented for dev purposes
        // setPainting(initialFormState)
      }}
    >
      <label>Name</label>
      <input
        type="text"
        name="name"
        value={painting.name}
        onChange={handleInputChange}
        required
      />
      <label>Year</label>
      <input
        type="text"
        name="year"
        value={painting.year}
        onChange={handleInputChange}
        required
      />
      <label>Description</label>
      <textarea
        name="description"
        value={painting.description}
        onChange={handleInputChange}
        required
      />
      <label>Source</label>
      <input
        type="text"
        name="source"
        value={painting.source}
        onChange={handleInputChange}
        required
      />
      <label>Artist</label>
      <input
        type="text"
        name="artist"
        value={painting.artist}
        onChange={handleInputChange}
        required
      />
      {isEditing ? (
        <input type="file" name="file" onChange={handleFileChange}></input>
      ) : (
        <input type="file" name="file" onChange={handleFileChange} required />
      )}
      <button>Add/Edit painting</button>
    </form>
  )
}

export default AddPainting
